// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/rates/stylesheet/rates.scss
 ** module id = 459
 ** module chunks = 1
 **/